import {
  useState,
  useEffect,
  PropsWithChildren,
  createContext,
  useContext
} from 'react';
import { useIdentityService } from './IdentityProvider';
import TimeDiscrepancy from '../components/timeDiscrepancy/TimeDiscrepancy';
import { useLiff } from './SessionProvider';
import LiffLayout from '../components/common/LiffLayout';
import NoneLayout from '../components/common/NoneLayout';

const TimeContext = createContext<{
  hasTimeDifference?: boolean;
}>({});

export const TimeProvider = ({ children }: PropsWithChildren<unknown>) => {
  const { identityClient } = useIdentityService();
  const liff = useLiff();

  // クライアントのPC時間とサーバー時間の時間差を5分まで許容する。
  const [hasTimeDifference, setHasTimeDifference] = useState<boolean>(false);
  const clientTime = new Date().getTime().toString();
  useEffect(() => {
    identityClient.getEnableDeviceTime(clientTime).then((hasTimeDifference) => {
      setHasTimeDifference(hasTimeDifference);
    });
  }, []);

  return (
    <>
      {hasTimeDifference ? (
        liff ? (
          <LiffLayout page={<TimeDiscrepancy />} />
        ) : (
          <NoneLayout page={<TimeDiscrepancy />} />
        )
      ) : (
        <TimeContext.Provider value={{ hasTimeDifference }}>
          {children}
        </TimeContext.Provider>
      )}
    </>
  );
};

export const useTime = () => useContext(TimeContext);
